<div class="dialog-footer" *ngIf="!customContent; else customFooterContent">
  <div class="dialog-footer__actions">
    <wlcm-button *ngIf="config.hasSecondaryBtn" styleType="text" (clicked)="secondaryBtnClicked.emit()">
      {{ config.secondaryBtnText }}
    </wlcm-button>

    <wlcm-button
      *ngIf="config.hasPrimaryBtn"
      (clicked)="primaryBtnClicked.emit()"
      [isDisabled]="isPrimaryBtnDisabled"
      [isLoading]="isLoading"
    >
      {{ config.primaryBtnText }}
    </wlcm-button>
  </div>
</div>

<ng-template #customFooterContent>
  <ng-content select="[napaCustomDialogContent]"></ng-content>
</ng-template>
